module.exports = __webpack_public_path__ + "img/logo.c2ff1d25.png";